import { useLazyQuery } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useCallback } from "react";

import getTopicQuery from "@apps/topic-sidebar/graphql/get-topic-sidebar-query";
import cache, { currentUserVar } from "@cache/cache";
import usePusher from "@components/use-pusher/use-pusher";
import { matchApolloErrorMessage } from "@helpers/helpers";

export default function PusherTopicUpdated({
  channelName,
}: {
  channelName: string;
}) {
  const currentUser = currentUserVar();

  // Queries & Mutations
  const [fetchTopic] = useLazyQuery(getTopicQuery, {});

  const handleTopicUpdated = useCallback(
    ({ topic }: { topic: { id: number } }) => {
      // If it's in the cache then we update
      const topicCacheId = cache.identify(topic);
      if (topicCacheId) {
        fetchTopic({
          variables: { topicId: topic.id },
        }).catch((errors) => {
          if (matchApolloErrorMessage(errors, "Invalid id")) {
            return;
          }
          captureException(errors);
        });
      }
    },
    [fetchTopic, currentUser]
  );

  usePusher(channelName, "topic_updated", handleTopicUpdated);

  return null;
}
